import { z } from "zod";
import { TaskType } from "./enums";

export const TaskTypeSchema = z.nativeEnum(TaskType);
